import { type EmblaCarouselType } from "embla-carousel";
import { useEffect } from "react";

/**
 * Embla Carousel 响应式重新初始化 Hook
 * 监听屏幕尺寸变化和 isSmallScreen 变化，自动重新初始化 Embla
 */
export function useEmblaResize(
  emblaApi: EmblaCarouselType | undefined,
  isSmallScreen?: boolean,
) {
  useEffect(() => {
    if (!emblaApi) return;

    setTimeout(() => {
      emblaApi.reInit();
    }, 100);
  }, [emblaApi, isSmallScreen]);
}
